import BaseModel from "./../base/baseModel";

export default class ModeloImpressaoUsuarioModel extends BaseModel {
    id?: number = null;
    modeloImpressaoId?: number = null;
    usuarioId?: number = null;
    usuarioNome: string = null;
    nomeImpressora: string = null;
}
